import { INPUT_FIELD_DEFAULT_HEIGHT } from '@constants';

export default {
  paper: {
    display: 'flex',
    flexDirection: 'column',
  },
  headerWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '6px 12px',
  },
  selectAllButton: {
    minWidth: 'auto',
    padding: '4px 8px',
    fontSize: '0.875rem',
    textTransform: 'none',
    color: (theme) => theme.palette.blues.primaryBlue500,
    '&:hover': {
      backgroundColor: (theme) => theme.palette.grays.gray100,
    },
  },
  resetButton: {
    minWidth: 'auto',
    padding: '4px 8px',
    fontSize: '0.875rem',
    textTransform: 'none',
    color: (theme) => theme.palette.blues.primaryBlue500,
    '&:hover': {
      backgroundColor: (theme) => theme.palette.grays.gray100,
    },
  },
  wrapper: ({ minWidth, align }) => ({
    '& .MuiInputLabel-root[data-shrink="true"]': {
      top: 0,
      color: (theme) => theme.palette.blues.primaryBlue500,
    },
    '& .MuiAutocomplete-listbox': {
      padding: '4px',
      margin: 0,
    },
    '& .MuiChip-label': {
      cursor: 'pointer',
      color: (theme) => theme.palette.blues.primaryBlue500,
      fontSize: '0.625rem',
    },
    '& .MuiChip-root': {
      backgroundColor: (theme) => theme.palette.blues.primaryBlue100,
      height: '20px',
      '& .MuiSvgIcon-root': {
        width: '11px',
        color: (theme) => theme.palette.blues.primaryBlue300,
      },
    },
    '& .MuiAutocomplete-tag': {
      fontSize: '.8rem',
      color: (theme) => theme.palette.blues.blue600,
    },

    '& .MuiAutocomplete-popper': {
      minWidth,
      ...align,
    },
    '& .MuiAutocomplete-paper': {
      backgroundColor: '#fff',
    },
    '& .MuiPaper-root': {
      boxShadow: 'none',
    },
    '& .MuiAutocomplete-clearIndicator': {
      svg: { width: '14px' },
      color: (theme) => theme.palette.blues.blue600,
      '&:hover': {
        background: 'none',
      },
    },
    '& .MuiOutlinedInput-root.Mui-disabled': {
      backgroundColor: (theme) => `${theme.palette.grays.gray100} !important`,
    },
    '& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
      borderColor: (theme) => `${theme.palette.grays.gray300} !important`,
    },
    '& .MuiInputLabel-root.Mui-disabled': {
      color: (theme) => `${theme.palette.grays.gray500} !important`,
    },
    '& .MuiSvgIcon-root.Mui-disabled': {
      color: (theme) => `${theme.palette.grays.gray400} !important`,
    },
  }),
  autocomplete: {
    width: '100%',
    '.MuiAutocomplete-popupIndicator': {
      '&:hover': {
        backgroundColor: 'transparent',
      },
      '::after': {
        content: '""',
      },
    },
  },
  checkbox: {
    padding: 0,
    '& .MuiSvgIcon-root': {
      fontSize: '16px',
    },
  },
  filterOptionItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '2px 6px',
    cursor: 'pointer',
    transition: 'background-color 0.15s',
    backgroundColor: 'transparent',
    borderRadius: '6px',
    marginBottom: '0',
    fontSize: '14px',
    margin: '5px 0',
    fontWeight: 400,
    color: (theme) => theme.palette.text.primary,
    '&:hover': {
      backgroundColor: (theme) => `${theme.palette.grays?.gray100} !important`,
    },
    '&.Mui-selected': {
      backgroundColor: 'transparent',
      color: (theme) => theme.palette.text.primary,
      '&:hover': {
        backgroundColor: (theme) => theme.palette.grays?.gray100,
      },
    },
    '&.Mui-focusVisible': {
      backgroundColor: (theme) => theme.palette.grays?.gray100,
    },
  },

  textfield: {
    width: '100%',
    height: '100%',
    fontSize: '0.875rem',
    color: (theme) => theme.palette.blues.primaryBlue,

    '& .MuiInputBase-input': {
      padding: '10px 12px',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: (theme) => `1px solid ${theme.palette.grays.gray300}`,
    },

    '& .MuiInputBase-root': {
      '&:hover': {
        backgroundColor: (theme) => theme.palette.grays.gray100,

        '& .MuiOutlinedInput-notchedOutline': {
          border: (theme) => `1px solid ${theme.palette.grays.gray300}`,
        },
      },
      '&.Mui-focused': {
        color: (theme) => theme.palette.blues.primaryBlue500,

        '& .MuiOutlinedInput-notchedOutline': {
          borderWidth: 1,
          borderColor: (theme) => theme.palette.blues.blue600,
          border: (theme) => `1px solid ${theme.palette.blues.blue600}`,
        },
      },
    },
    '& .MuiOutlinedInput-root': {
      height: INPUT_FIELD_DEFAULT_HEIGHT,
    },
  },
  textfieldWithValue: {
    color: (theme) => theme.palette.blues.primaryBlue500,
    backgroundColor: (theme) => theme.palette.blues.lightestBlue,

    '& .MuiOutlinedInput-notchedOutline': {
      border: (theme) => `1px solid ${theme.palette.blues.blue600}`,
    },
    '& .MuiInputBase-root': {
      '&.Mui-focused': {
        backgroundColor: (theme) => theme.palette.blues.lightestBlue,

        '& .MuiOutlinedInput-notchedOutline': {
          borderWidth: 1,
          borderColor: (theme) => theme.palette.blues.blue600,
          border: (theme) => `1px solid ${theme.palette.blues.blue600}`,
        },
      },
      '&:hover': {
        backgroundColor: (theme) => theme.palette.blues.lightestBlue,

        '& .MuiOutlinedInput-notchedOutline': {
          border: (theme) => `1px solid ${theme.palette.blues.blue600}`,
        },
      },
    },
    '& .MuiSvgIcon-root': {
      color: (theme) => theme.palette.blues.primaryBlue,
    },
  },
  tooltipContainer: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'nowrap',
  },
  tooltipContent: {
    padding: '8px',
    paddingTop: '25px',
    paddingRight: '0px',
    maxWidth: 400,
    backgroundColor: 'white',
    position: 'relative',
  },
  tooltipChipsWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '4px',
    maxHeight: 400,
    overflowY: 'auto',
    paddingRight: '8px',
  },
  tooltipCloseButton: {
    position: 'absolute',
    top: '4px',
    right: '2px',
    padding: '1px',
    minWidth: 'auto',
    width: 12,
    height: 12,
    zIndex: 1,
    color: (theme) => theme.palette.grays.gray600,
    '&:hover': {
      backgroundColor: (theme) => theme.palette.grays.lightestGray,
      color: (theme) => theme.palette.grays.gray800,
    },
  },
  tooltipChip: {
    maxWidth: '150px',
    height: '18px',
    fontSize: '10px',
    paddingRight: '4px',
    backgroundColor: (theme) => theme.palette.blues.primaryBlue100,
    color: (theme) => theme.palette.blues.primaryBlue500,
    '& .MuiChip-label': {
      fontSize: '10px',
      padding: '0 6px',
    },
    '& .MuiChip-deleteIcon': {
      fontSize: '10px',
      width: '10px',
      height: '10px',
      margin: '0 2px 0 0',
      color: (theme) => theme.palette.blues.primaryBlue500,
      '&:hover': {
        color: (theme) => theme.palette.blues.primaryBlue300,
      },
    },
  },
  tooltip: {
    backgroundColor: 'white !important',
    color: 'text.primary',
    border: (theme) => `1px solid ${theme.palette.grays.gray300}`,
    boxShadow: (theme) => theme.customShadows.lightShadow,
    '& .MuiTooltip-arrow': {
      color: 'white',
    },
  },
  moreChip: {
    cursor: 'pointer',
    border: 'none',
    '&:hover': {
      backgroundColor: (theme) => theme.palette.grays.lightestGray,
    },
  },
  displayTag: (isLargeScreen = false) => ({
    maxWidth: `${isLargeScreen ? '100px' : '70px'} !important`,
    '& .MuiChip-label': {
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      maxWidth: '100%',
      display: 'block',
    },
  }),
};
